import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import AnimarAlScroll from "../Animaciones/AnimarAlScroll";
import "./Faq.css";

const _preguntasUnas = [
  {
    pregunta: "¿Los diseños están incluidos en el precio?",
    respuesta: [
      "Los precios se dividen en Liso / Simple y Diseño Glow.",
      "Los diseños más elaborados, con mucho detalle, relieve, piedras o inspiraciones complejas se cotizan según el caso.",
    ],
  },
  {
    pregunta: "¿Cada cuánto se recomienda hacer mantenimiento de uñas?",
    respuesta:
      "Depende del crecimiento y del cuidado de cada persona, pero en general se recomienda realizar mantenimiento cada 15 a 21 días para mantener el trabajo prolijo y evitar desprendimientos o quiebres.",
  },
  {
    pregunta: "¿El retiro está incluido?",
    respuesta: [
      "El retiro está incluido en mantenimientos mensuales de clientas GlowRoom, siempre que el trabajo anterior haya sido realizado en el salón.",
      "Si el producto es de otro salón, o si se desea retirar sin realizar un nuevo servicio, se cobra aparte.",
    ],
  },
  {
    pregunta: "¿Qué pasa si mis uñas están débiles o dañadas?",
    respuesta:
      "Antes de realizar cualquier servicio se evalúa el estado de la uña natural. Si la uña está muy debilitada, se puede recomendar una opción más suave o un tratamiento previo para no comprometer su salud.",
  },
  {
    pregunta: "¿Qué diferencia hay entre capping y Soft Gel?",
    respuesta:
      "El capping se realiza sobre el largo natural de la uña para aportar firmeza y protección. El Soft Gel permite alargar la uña mediante tips, logrando más largo y estructura.",
  },
  {
    pregunta: "¿Qué pasa si tengo hongos, heridas o molestias en pies/uñas?",
    respuesta:
      "Los servicios son estéticos. En caso de hongos, heridas, infecciones, uñas encarnadas o molestias importantes, se recomienda consultar previamente con podóloga/o o profesional correspondiente.",
  },
];

const _preguntasPestanas = [
  {
    pregunta: "¿Cuándo corresponde mantenimiento de pestañas?",
    respuesta: [
      "El mantenimiento aplica hasta 2 o 3 semanas, siempre que quede una cantidad adecuada de extensiones.",
      "Pasadas las 3 semanas, o si queda muy poca cantidad, se toma como colocación nueva.",
    ],
  },
  {
    pregunta: "¿Puedo hacerme mantenimiento de pestañas varias veces seguidas?",
    respuesta:
      "No. El mantenimiento se realiza una sola vez. Luego, para el siguiente turno, se realiza retiro y colocación nueva desde cero.",
  },
  {
    pregunta: "¿Cuánto duran las extensiones de pestañas?",
    respuesta:
      "La duración depende del ciclo natural de tus pestañas y de los cuidados posteriores. En general, se recomienda realizar mantenimiento dentro de las 2 a 3 semanas.",
  },
  {
    pregunta: "¿Puedo ir con maquillaje al turno de pestañas?",
    respuesta: [
      "Lo ideal es asistir sin maquillaje en los ojos, sin máscara de pestañas y sin productos oleosos.",
      "Venir con maquillaje puede afectar directamente la retención de las extensiones, ya que dificulta la correcta adherencia del adhesivo.",
    ],
  },
  {
    pregunta: "¿Qué cuidados tienen las extensiones una vez colocadas?",
    respuesta:
      "Evitá el agua y el vapor durante las primeras 24 horas, no uses rímel ni las frotes, limpialas con un shampoo específico y peinalas suavemente a diario. Dormir boca arriba ayuda a que duren más.",
  },
];

const _preguntasTurnos = [
  {
    pregunta: "¿Cómo se confirma el turno?",
    respuesta:
      "El turno se confirma con una seña de $500, que se descuenta del total del servicio.",
  },
  {
    pregunta: "¿Qué pasa si cancelo o no asisto?",
    respuesta: [
      "Los cambios o cancelaciones deben avisarse con mínimo 48 horas de anticipación.",
      "En caso de cancelar fuera de ese plazo o no asistir, la seña se pierde.",
    ],
  },
  {
    pregunta: "¿Qué pasa si llego tarde?",
    respuesta:
      "Se cuenta con una tolerancia de 15 minutos. Pasado ese tiempo, el turno puede ser reprogramado según disponibilidad.",
  },
];

const _categorias = [
  { titulo: "Uñas", preguntas: _preguntasUnas },
  { titulo: "Pestañas", preguntas: _preguntasPestanas },
  { titulo: "Turnos y reservas", preguntas: _preguntasTurnos },
];

const _contenedorFaq = {
  oculto: {},
  visible: { transition: { staggerChildren: 0.06 } },
};

const _itemFaqAnim = {
  oculto: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 260, damping: 18 } },
};

function ItemFaq({ pregunta, respuesta }) {
  const [abierto, setAbierto] = useState(false);
  const [primeraApertura, setPrimeraApertura] = useState(true);
  const [mostrarBarrido, setMostrarBarrido] = useState(false);
  const _parrafos = Array.isArray(respuesta) ? respuesta : [respuesta];

  return (
    <motion.div className={"faq-item " + (abierto ? "abierto" : "")} variants={_itemFaqAnim}>
      <button
        className="faq-pregunta"
        onClick={() => setAbierto(!abierto)}
        aria-expanded={abierto}
      >
        <span>{pregunta}</span>
        <span className="faq-chevron">⌄</span>
      </button>

      <AnimatePresence initial={false}>
        {abierto && (
          <motion.div
            className={"faq-respuesta-contenedor " + (mostrarBarrido ? "faq-respuesta-nueva" : "")}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            onAnimationComplete={() => {
              if (primeraApertura) {
                setPrimeraApertura(false);
                setMostrarBarrido(true);
              }
            }}
          >
            {_parrafos.map((parrafo, i) => (
              <p key={i} className="faq-respuesta">
                {parrafo}
              </p>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

function CategoriaFaq({ categoria }) {
  const [abierta, setAbierta] = useState(false);

  return (
    <div className="faq-categoria">
      <button
        className={"faq-categoria-trigger " + (abierta ? "abierto" : "")}
        onClick={() => setAbierta(!abierta)}
        aria-expanded={abierta}
      >
        <span className="faq-categoria-titulo">{categoria.titulo}</span>
        <span className="faq-categoria-chevron">⌄</span>
      </button>

      <AnimatePresence initial={false}>
        {abierta && (
          <motion.div
            className="faq-categoria-desplegable"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: "easeInOut" }}
          >
            <motion.div
              className="faq-lista"
              variants={_contenedorFaq}
              initial="oculto"
              animate="visible"
            >
              {categoria.preguntas.map((item) => (
                <ItemFaq
                  key={item.pregunta}
                  pregunta={item.pregunta}
                  respuesta={item.respuesta}
                />
              ))}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

function Faq() {
  return (
    <section className="faq" id="faq">
      <AnimarAlScroll>
      <div className="contenedor">
        <div className="seccion-titulo">
          <p>Antes de reservar</p>
          <div className="linea-decorativa"></div>
          <h2>Preguntas frecuentes</h2>
        </div>

        {_categorias.map((categoria) => (
          <CategoriaFaq key={categoria.titulo} categoria={categoria} />
        ))}
      </div>
      </AnimarAlScroll>
    </section>
  );
}

export default Faq;
